import { HOSTNAME, HOSTS, IS_COOKIE_DEBUG, IS_DEV, IS_STAGE, IS_PROD, IS_LOCAL } from '@/modules/env'

export const getCookieDomain = () => {
  // Bare localhost / loopback / LAN can't use a .wisk.test cookie — fall back to no domain
  if (HOSTNAME === HOSTS.LOCALHOST || HOSTNAME === HOSTS.LOOPBACK || HOSTNAME.startsWith('192.168.')) return ''
  if (IS_LOCAL) return '.wisk.test'
  if (IS_DEV) return '.wisk.dev'
  if (IS_STAGE) return '.wisk.cool'
  if (IS_PROD) return '.wisk.ai'
  return ''
}

export const getStockAppBaseUrl = () => {
  if (IS_COOKIE_DEBUG) return 'https://stock.wisk.test'
  if (IS_LOCAL) return 'http://localhost:3000' // wisk-stock
  // TODO: check URLs when wisk-stock is deployed to dev/stage/prod
  if (IS_DEV) return 'https://stock.wisk.dev'
  if (IS_STAGE) return 'https://stock.wisk.cool'
  if (IS_PROD) return 'https://stock.wisk.ai'
  console.warn('getStockAppBaseUrl: unknown environment, sub app URL not configured')
  return ''
}

